export function getConfig() {
  let config = {
    hostHttpProtocol: 'https',
  };
  config = Object.assign(config, {
    host: {
      prd: 'notify-api.sonice-aioe.com',
      stg: 'notify-api.sonice-aioe.com',
      dev: 'notify-api.sonice-aioe.com',
    }[BUILD_MODE],
    domain: {
      prd: 'sonice-notify-client.web.app',
      stg: 'sonice-notify-client-staging.web.app',
      dev: '172.16.211.6:8080',
    }[BUILD_MODE],
  });
  return config;
}

//version 不在這裡, 在 /build/version.txt
//說什麼要檢查版本推上去後, App 會打 axios 遠端下載 txt 比對版本
//如果有異動 App 就會自動刷新 refresh, 反正不是我做的www
